// Components
import { StyledActionsWrap, StyledActionButton, StyledLink } from './ProductVariationsActionsStyles';
import { EditIcon, TrashIcon } from '@/icons';
import { COLORS } from '@/theme';

// Models
import { IProductVariation } from '@/models/products.model';
import { ROUTES } from '@/models/router.model';

type TProductVariationsActionsProps = {
  record: IProductVariation;
  handleDeleteVariation: (variation: IProductVariation) => void;
};

const ProductVariationsActions = ({ handleDeleteVariation, record }: TProductVariationsActionsProps) => {
  const onDeleteButtonClick = () => handleDeleteVariation(record);

  return (
    <StyledActionsWrap>
      <StyledLink $color={COLORS.PALE_YELLOW} href={`${ROUTES.PRODUCTS}/${record.id}`} target="_blank" rel="noreferrer">
        <EditIcon />
      </StyledLink>
      <StyledActionButton $color={COLORS.RED} onClick={onDeleteButtonClick}>
        <TrashIcon />
      </StyledActionButton>
    </StyledActionsWrap>
  );
};

export default ProductVariationsActions;
